export default __webpack_public_path__ + "src/images/packages/saseka-tented-camp/565e932a2d82cfb9b333b5e2e3915281-4.jpg";